<div class="fade modal modal-static pg-show-modal" id="modal-invalid-profile" tabindex="-1" role="dialog"
    aria-hidden="true" data-backdrop="static" data-keyboard="false">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">Postular a anuncio</h4>
                <button type="button" class="close" data-dismiss="modal" aria-hidden="true"
                    title="Cerrar modal">&times;</button>
            </div>
            <div class="modal-body">
                <div class="form-row">
                    <div class="col-12">
                        <div class="text-center">
                            <div class="max-width-455 ml-auto mr-auto">
                                <h3 class="font-size-22 font-weight-bold text-primary">Aún no puedes postular</h3>
                                <p class="font-size-18">
                                    Debes llenar todos los campos obligatorios antes de enviar cualquier postulación en
                                    ProfeJOBS</p>
                                <p class="font-size-18 font-weight-bold no-mgn text-primary">
                                    ¡Completa tu perfil para enviar esta postulación!</p>
                            </div>
                           <div
                                class="alert alert-icon-text alert-warning d-flex justify-content-center mgn-top-bottom-20 text-dark">
                                <div class="inner-section">
                                    <i class="pj-ico pj-ico-ampolleta text-primary"></i>
                                </div>
                                <div class="inner-section">
                                    <p class="font-size-13 no-mgn">Te marcaremos en rojo los campos mínimos que debes
                                        llenar para enviar esta postulación.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="form-row">
                    <div class="col-12">
                        <div class="space-items-15 text-center">
                            <button class="btn btn-outline-primary" type="button" data-dismiss="modal">Cerrar</button>
                            <a class="btn btn-primary" data-dismiss="modal"
                                (click)="helpService.navigateToEmployeeEdit(idJob)">Completar mi perfil</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
